/**
 * Container Layout
 * Page containers with max-width and centering
 */

import React from "react";
import { SpacingToken } from "../foundation";

export type ContainerSizeToken = "small" | "medium" | "large" | "extraLarge" | "full";

export interface ContainerProps {
  children: React.ReactNode;
  size?: ContainerSizeToken;
  padding?: SpacingToken;
  centerContent?: boolean;
  className?: string;
}

export function Container({
  children,
  size = "large",
  padding,
  centerContent = false,
  className,
  ...props
}: ContainerProps) {
  // Implementation will be added later
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
}
